import { InputNumber, message, Select } from "antd";
import "antd/es/select/style/css";
import "antd/es/input-number/style/css";
import "antd/es/message/style/css";
import React, { useState } from "react";
import cs from "classnames";
import { SelectProps } from "antd";
import IconFont from "@meitu/xdesign-icon-font";
import styles from "./index.module.css";
import { statTrack } from "@/utils/mtstat";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { MAX_PAGE_COUNT } from "@/constants/workbench";

const { Option } = Select;

const pageNumberSelect = [
  {
    name: "自动分页",
    value: "0",
  },
  {
    name: "1页",
    value: "1",
  },
  {
    name: "2页",
    value: "2",
  },
  {
    name: "3页",
    value: "3",
  },
  {
    name: "4页",
    value: "4",
  },
  {
    name: "5页",
    value: "5",
  },
];

interface PageSizeSelectProps {
  value?: string;
  onChange?: (v: string) => void;
  style?: React.CSSProperties;
  placement?: SelectProps["placement"];
  customLabel?: boolean;
  className?: string;
  theme?: "light" | "dark";
  size?: SizeType;
}

const PageNumberSelect = (props: PageSizeSelectProps) => {
  const {
    value,
    onChange,
    style,
    placement = "bottomLeft",
    customLabel = false,
    className = "",
    theme = "light",
    size = "middle",
  } = props;

  const [open, setOpen] = useState(false);

  const getLabelFromValue = (val: string) => {
    const found = pageNumberSelect.find((item) => item.value === val);
    if (found) return `页数：${found.name}`;
    return `页数：${val}页`;
  };

  return (
    <Select
      labelInValue
      open={open}
      value={value ? { value, label: getLabelFromValue(value) } : undefined}
      onDropdownVisibleChange={(v) => setOpen(v)}
      onInputKeyDown={(e) => {
        e.key === "Enter" && e.stopPropagation();
      }}
      onChange={(selected) => {
        const isOption = pageNumberSelect.some(
          (item) => item.value === selected.value
        );
        console.log("selected", selected);
        if (isOption) {
          onChange?.(selected.value);
          setOpen(false);
        }
      }}
      dropdownRender={(menu) => (
        <>
          {menu}
          <div
            style={{ paddingLeft: 16 }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <InputNumber
              id="pageNumberInput"
              bordered={false}
              controls={false}
              min={"0"}
              className={styles.pageNumberInput}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              value={value === "0" ? null : value}
              style={{ width: 30, borderBottom: "1px solid #38f", padding: 0 }}
              onChange={(val) => {
                if (val && Number(val) > MAX_PAGE_COUNT) {
                  statTrack("toast_show", {
                    notification_type: "page_limit_notification",
                    position: "aippt_home",
                  });
                  message.error(`最多支持生成${MAX_PAGE_COUNT}页`);
                  onChange?.(MAX_PAGE_COUNT.toString());
                  return;
                }
                onChange?.(val || "0");
              }}
            />
            页
          </div>
        </>
      )}
      className={cs({
        [styles.pageSelect]: true,
        [styles.pageSelectOpen]: open,
        [className]: !!className,
        [styles.pageSelectDark]: theme === "dark",
      })}
      size={size}
      style={style}
      placement={placement}
      popupClassName={
        theme === "dark"
          ? styles.pageSelectDarkPopup
          : styles.pptBodyPageSelectPopup
      }
      optionLabelProp="label"
      suffixIcon={
        <IconFont
          color="#abadb2"
          fontSize={12}
          name={open ? "ChevronUpBlack" : "ChevronDownBlack"}
        />
      }
    >
      {pageNumberSelect.map((item) => (
        <Option
          key={item.value}
          value={item.value}
          label={customLabel ? `页数：${item.name}` : item.name}
        >
          {item.name}
          {value === item.value && (
            <IconFont
              style={{ marginLeft: 12 }}
              fontSize={14}
              color="#38f"
              name="CheckBlack"
            />
          )}
        </Option>
      ))}
    </Select>
  );
};

export default React.memo(PageNumberSelect);
